// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d02c0fc8","453":"d294c250","455":"f9f7afb5"}[chunkId] + ".chunk.js";
};